<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Data Karyawan</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Nama (wajib)"
                  required
                  v-model="formData.nama"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Status (wajib)"
                  required
                  v-model="formData.status"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Telp"
                  required
                  v-model="formData.telp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Alamat"
                  required
                  v-model="formData.alamat"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Keterangan"
                  required
                  v-model="formData.ket"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="['Y', 'N']"
                  label="Aktif (wajib)"
                  required
                  v-model="formData.is_active"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  :items="[{text:'Pontianak',value:'pontianak'},{text:'Jakarta',value:'jakarta'}]"
                  label="Lokasi"
                  clearable
                  v-model="formData.lokasi"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Username"
                  autocomplete="off"
                  v-model="formData.username"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Password Baru (kosongkan jika tidak diubah)"
                  type="password"
                  autocomplete="new-password"
                  :readonly="!passwordEditable"
                  @mousedown="enablePasswordEdit"
                  @focus="onPasswordFocus"
                  @input="onPasswordInput"
                  v-model="formData.password"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Tanggal Masuk"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      v-model="formData.tgl_masuk"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.tgl_masuk"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <div class="text-subtitle-2 mb-2">Hak Akses Menu</div>
                <v-treeview
                  v-if="permissionsLoaded"
                  v-model="formData.permissions"
                  :items="menuItems"
                  selectable
                  selected-color="primary"
                  item-key="to"
                  item-text="title"
                  open-all
                  dense
                ></v-treeview>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Tanggal Keluar"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      v-model="formData.tgl_keluar"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.tgl_keluar"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            :disabled="loading"
            tabindex="-1"
            @click="
              $emit('close-modal');
              resetFormData();
            "
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            :loading="loading"
            :disabled="loading || !permissionsLoaded"
            text
            @click="updateData"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import store from "@/store";

export default {
  name: "EditModal",
  props: ["openModal", "id"],
  data() {
    return {
      formData: {
        nama: "",
        status: "",
        alamat: "",
        telp: "",
        ket: "",
        is_active: "",
        lokasi: "",
        tgl_masuk: "",
        tgl_keluar: "",
        username: "",
        password: "",
        permissions: []
      },
      menu1: false,
      menu2: false,
      loading: false,
      permissionsLoaded: false,
      passwordEditable: false,
      passwordModified: false
    };
  },
  computed: {
    menuItems() {
      return store.state.app.items
        .map(i => {
          const item = {
            to: normalizePath(i.to),
            title: i.title
          };
          if (i.items && i.items.length) {
            item.children = i.items.map(s => ({
              to: normalizePath(s.to),
              title: s.title
            }));
          }

          return item;
        });
    },
    validPermissionPaths() {
      return collectPermissionPaths(store.state.app.items);
    }
  },
  watch: {
    openModal(val) {
      if (val) {
        this.resetFormData();
        this.fetchData();
      }
    }
  },
  methods: {
    enablePasswordEdit() {
      this.passwordEditable = true;
    },
    onPasswordFocus() {
      this.passwordEditable = true;
    },
    onPasswordInput(val) {
      if (!this.passwordEditable) {
        this.formData.password = "";
        return;
      }
      this.passwordModified = Boolean(val && String(val).trim() !== "");
    },
    async fetchData() {
      this.loading = true;
      this.permissionsLoaded = false;
      this.passwordEditable = false;
      this.passwordModified = false;
      this.formData.password = "";

      await axios
        .get(`karyawan/${this.id}`)
        .then(res => {
          this.formData.nama = res.data.nama;
          this.formData.status = res.data.status;
          this.formData.alamat = res.data.alamat;
          this.formData.telp = res.data.telp;
          this.formData.ket = res.data.ket;
          this.formData.is_active = res.data.is_active;
          this.formData.lokasi = res.data.lokasi || "";
          this.formData.tgl_masuk = res.data.tgl_masuk;
          this.formData.tgl_keluar = res.data.tgl_keluar;
          this.formData.username = res.data.username;
          this.formData.password = "";
          this.passwordEditable = false;
          this.passwordModified = false;
          this.formData.permissions = normalizeSelectedPermissions(
            parsePermissions(res.data.permissions),
            this.validPermissionPaths
          );

          this.permissionsLoaded = true;
          this.loading = false;
        })
        .catch(err => {
          this.permissionsLoaded = false;
          this.loading = false;

          alert(err.response?.data?.message || "Gagal memuat data karyawan");
        });
    },
    async updateData() {
      this.loading = true;
      const payload = {
        ...this.formData,
        permissions: normalizeSelectedPermissions(
          this.formData.permissions,
          this.validPermissionPaths
        )
      };

      // An empty or untouched password means "keep the existing password".
      // Do not send the field so browser autofill or an older API cannot accidentally replace it.
      if (
        !this.passwordModified ||
        !payload.password ||
        !String(payload.password).trim()
      ) {
        delete payload.password;
      }

      await axios
        .put(`karyawan/${this.id}`, payload)
        .then(res => {
          try {
            const currentUser = JSON.parse(
              localStorage.getItem("user") || "{}"
            );
            if (
              res?.data?.user_id &&
              String(currentUser.user_id) === String(res.data.user_id)
            ) {
              const merged = { ...currentUser, ...res.data };
              localStorage.setItem("user", JSON.stringify(merged));
              store.commit("app/authUser", merged);
            }
          } catch (e) {
            // ignore storage parse error
          }
          this.loading = false;
          this.$emit("close-modal");

          this.resetFormData();
        })
        .catch(err => {
          this.loading = false;

          alert(err.response?.data?.message || "Gagal menyimpan data karyawan");
        });
    },
    resetFormData() {
      this.formData.nama = "";
      this.formData.status = "";
      this.formData.alamat = "";
      this.formData.telp = "";
      this.formData.ket = "";
      this.formData.is_active = "";
      this.formData.lokasi = "";
      this.formData.tgl_masuk = "";
      this.formData.tgl_keluar = "";
      this.formData.username = "";
      this.formData.password = "";
      this.formData.permissions = [];
      this.permissionsLoaded = false;
      this.passwordEditable = false;
      this.passwordModified = false;
    }
  }
};

function normalizePath(path) {
  const clean = String(path || "").replace(/\/$/, "");
  return clean || "/";
}

function collectPermissionPaths(items) {
  const paths = [];

  (items || []).forEach(item => {
    if (item.items && item.items.length) {
      item.items.forEach(child => paths.push(normalizePath(child.to)));
      return;
    }

    paths.push(normalizePath(item.to));
  });

  return [...new Set(paths)];
}

function normalizeSelectedPermissions(selected, validPaths) {
  const valid = new Set(validPaths);

  return (selected || [])
    .map(normalizePath)
    .filter(path => valid.has(path));
}

function parsePermissions(permissions) {
  if (Array.isArray(permissions)) {
    return permissions.map(normalizePath);
  }

  if (typeof permissions !== "string") {
    return [];
  }

  try {
    const parsed = JSON.parse(permissions || "[]");
    return Array.isArray(parsed) ? parsed.map(normalizePath) : [];
  } catch (e) {
    return [];
  }
}
</script>
